export default "__VITE_ASSET__Du$zJxzF__"